module.exports = __webpack_public_path__ + "img/160.d634c007.jpg";